<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
      title="消息详情"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="msg-details">
      <div class="hd">
        <h2 class="title">操作说明</h2>
        <!-- <p class="date">{{ newModel.AddDateTime }}</p> -->
      </div>
      <van-divider />
      <div class="bd">
        <div v-html="newModel.Content"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newModel: [],
    };
  },
  components: {},
  methods: {
    init() {
      var that = this;
      that.$store.dispatch({
        type: "GetExplain"
      }).then(res=>{
          this.newModel=res;
      },error=>{});
    },
    onClickLeft() {
      this.$router.go(-1);
    },
  },
  created() {
      this.init();
  },
};
</script>

<style scoped>
.msg-details {
  background-color: #fff;
  padding: 15px;
}
.msg-details > .hd {
}
.msg-details > .hd > .title {
  font-size: 15px;
  font-weight: normal;
  line-height: 1.5;
  text-align: center;
}
.msg-details > .hd > .date {
  font-size: 12px;
  color: #bbb;
  text-align: center;
  margin-top: 6px;
}
.msg-details > .bd {
  margin-top: 6px;
  font-size: 14px;
  color: #555;
}
</style>
